import { Injectable } from "@angular/core";
import { EnumService } from "./enum.service";

@Injectable({
    providedIn: "root",
})
export class StaticDataService {
    static OfflineModeSyncMinDays = 7;

    static dateTimeFormatForDb = "YYYY-MM-DDTHH:mm:ss";
    static dateTimeFormat = "YYYY-MM-DD HH:mm:ss.000";
    static dateTimeFormatAMPM = "YYYY-MM-DD hh:mm A";
    static dateFormat = "YYYY-MM-DD";
    static timeFormat = "hh:mmA";
    static photoQuality = 80;
    static photoMaxHeight = 500;
    static photoMaxWidth = 500;
    static photoHDHeight = 1080;
    static photoHDWidth = 1920;
    static userDefaultGuid = "00000000-0000-0000-0000-000000000000";
    static dateZeroTimeFormat = "YYYY-MM-DDT00:00:00.000";
    static dateZeroDateTimeFormat = "YYYY-MM-DD 00:00:00.000";
    static userDefaultDate = "0001-01-01T00:00:00";
    static userUnsetDate = "0001-01-01";
    static offlineFilesFolderName = "offline_files";
    static formStateFileFolderName = "form_state_files";
    static formImagesFolderName = "form_images";
    static disableExifHeaderStripping = "disableExifHeaderStripping";

    static bodyParts = [
        {
            type: "Head",
            langkey: "HEAD",
            parts: [
                {
                    name: "Head Soft Tissue",
                    langkey: "HEAD_SOFT_TISSUE",
                    id: EnumService.AccidentBodyPartsIds.HeadSoftTissue,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                    },
                },
                {
                    name: "Face",
                    langkey: "FACE",
                    id: EnumService.AccidentBodyPartsIds.HeadFace,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                    },
                },
            ],
        },
        {
            type: "Torso",
            langkey: "TORSO",
            parts: [
                {
                    name: "Abdomen",
                    langkey: "ABDOMEN",
                    id: EnumService.AccidentBodyPartsIds.TorsoAbdomen,
                    path: {
                        fill: "#A1A8CA",
                    },
                },
                {
                    name: "Chest",
                    langkey: "CHEST",
                    id: EnumService.AccidentBodyPartsIds.TorsoChest,
                    path: {
                        fill: "#A0A8C9",
                        stroke: "#CACEE1",
                    },
                },
                {
                    name: "Neck",
                    langkey: "NECK",
                    id: EnumService.AccidentBodyPartsIds.TorsoNeck,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                    },
                },
                {
                    name: "Ribs",
                    langkey: "RIBS",
                    id: EnumService.AccidentBodyPartsIds.TorsoRibs,
                    path: {
                        fill: "#B6BEDF",
                        stroke: "#CACEE1",
                    },
                },
            ],
        },
        {
            type: "Back",
            langkey: "BACK",
            parts: [
                {
                    name: "Upper Back",
                    langkey: "UPPER_BACK",
                    id: EnumService.AccidentBodyPartsIds.BackUpperBack,
                    path: {
                        fill: "#8B93B8",
                    },
                },
                {
                    name: "Lower Back",
                    langkey: "LOWER_BACK",
                    id: EnumService.AccidentBodyPartsIds.BackLowerBack,
                    path: {
                        fill: "#8B93B8",
                    },
                },
                {
                    name: "Buttocks",
                    langkey: "BUTTOCKS",
                    id: EnumService.AccidentBodyPartsIds.BackButtocks,
                    path: {
                        fill: "#8B93B8",
                    },
                },
            ],
        },
        {
            type: "Arms",
            langkey: "ARMS",
            parts: [
                {
                    name: "Shoulder - Right",
                    langkey: "SHOULDER_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsShoulderRight,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                    },
                },
                {
                    name: "Shoulder - Left",
                    langkey: "SHOULDER_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsShoulderLeft,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                    },
                },
                {
                    name: "Upper Arm - Right",
                    langkey: "UPPER_ARM_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.UpperArmRight,
                    path: {
                        fill: "#A1A8CA",
                    },
                },
                {
                    name: "Upper Arm - Left",
                    langkey: "UPPER_ARM_LEFT",
                    id: EnumService.AccidentBodyPartsIds.UpperArmLeft,
                    path: {
                        fill: "#A1A8CA",
                    },
                },
                {
                    name: "Elbow - Right",
                    langkey: "ELBOW_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsElbowRight,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                        strokeWidth: 2.44942,
                    },
                },
                {
                    name: "Elbow - Left",
                    langkey: "ELBOW_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsElbowLeft,
                    path: {
                        fill: "#A1A8CA",
                        stroke: "#CACEE1",
                        strokeWidth: 2.44942,
                    },
                },
                {
                    name: "Lower Arm - Right",
                    langkey: "LOWER_ARM_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsLowerRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Lower Arm - Left",
                    langkey: "LOWER_ARM_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsLowerLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Wrist - Right",
                    langkey: "WRIST_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsWristRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Wrist - Left",
                    langkey: "WRIST_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsWristLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Hand - Right",
                    langkey: "HAND_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsHandRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Hand - Left",
                    langkey: "HAND_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsHandLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Finger - Right",
                    langkey: "FINGER_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.ArmsFingerRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Finger - Left",
                    langkey: "FINGER_LEFT",
                    id: EnumService.AccidentBodyPartsIds.ArmsFingerLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
            ],
        },
        {
            type: "Legs",
            langkey: "LEGS",
            parts: [
                {
                    name: "Ankle - Right",
                    langkey: "ANKLE_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LegsAnkleRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Ankle - Left",
                    langkey: "ANKLE_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LegsAnkleLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Foot - Right",
                    langkey: "FOOT_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LegsFootRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Foot - Left",
                    langkey: "FOOT_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LegsFootLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Lower Leg - Right",
                    langkey: "LOWER_LEG_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LowerLegRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Lower Leg - Left",
                    langkey: "LOWER_LEG_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LowerLegLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },

                {
                    name: "Knee - Right",
                    langkey: "KNEE_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LegsKneeRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Knee - Left",
                    langkey: "KNEE_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LegsKneeLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Upper Leg - Right",
                    langkey: "UPPER_LEG_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LegsUpperRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Upper Leg - Left",
                    langkey: "UPPER_LEG_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LegsUpperLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Toe - Right",
                    langkey: "TOE_RIGHT",
                    id: EnumService.AccidentBodyPartsIds.LegsToeRight,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
                {
                    name: "Toe - Left",
                    langkey: "TOE_LEFT",
                    id: EnumService.AccidentBodyPartsIds.LegsToeLeft,
                    path: {
                        fill: "#A0A8C9",
                    },
                },
            ],
        },
    ];

    static supportedVideoFormats = ["mov", "mp4", "mpeg", "mpg", "wmv", "3gp"];
    static supportedImageFormats = ["jpeg", "jpg", "png", "gif", "heic", "heif"];

    static videoFormats = [
        "avi",
        "flv",
        "mov",
        "mpeg",
        "mpg",
        "mp2",
        "mp4",
        "qt",
        "vob",
        "wmv",
        "avchd",
        "mkv",
        "webm",
        "3gp",
    ];
    static documentFormats = [
        "doc",
        "docx",
        "pdf",
        "txt",
        "odt",
        "rtf",
        "tex",
        "wpd",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "csv",
        "html",
        "htm",
        "md"
    ];
    
    

    static fileMimeTypes = {
        "3dmf": "x-world/x-3dmf",
        "3dm": "x-world/x-3dmf",
        avi: "video/x-msvideo",
        ai: "application/postscript",
        bin: "application/octet-stream",
        bmp: "image/bmp",
        cab: "application/x-shockwave-flash",
        c: "text/plain",
        "c++": "text/plain",
        class: "application/java",
        css: "text/css",
        csv: "text/comma-separated-values",
        cdr: "application/cdr",
        doc: "application/msword",
        dot: "application/msword",
        // docx: "application/msword",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        dwg: "application/acad",
        eps: "application/postscript",
        exe: "application/octet-stream",
        gif: "image/gif",
        gz: "application/gzip",
        gtar: "application/x-gtar",
        flv: "video/x-flv",
        fh4: "image/x-freehand",
        fh5: "image/x-freehand",
        fhc: "image/x-freehand",
        help: "application/x-helpfile",
        hlp: "application/x-helpfile",
        html: "text/html",
        htm: "text/html",
        ico: "image/x-icon",
        imap: "application/x-httpd-imap",
        inf: "application/inf",
        jpe: "image/jpeg",
        jpeg: "image/jpeg",
        jpg: "image/jpeg",
        js: "application/x-javascript",
        java: "text/x-java-source",
        latex: "application/x-latex",
        log: "text/plain",
        m3u: "audio/x-mpequrl",
        midi: "audio/midi",
        mid: "audio/midi",
        mov: "video/quicktime",
        mp3: "audio/mpeg",
        mpeg: "video/mpeg",
        mpg: "video/mpeg",
        mp2: "video/mpeg",
        mp4: "video/mp4",
        webm: "video/webm",
        "3gp": "video/3gp",
        ogg: "application/ogg",
        phtml: "application/x-httpd-php",
        php: "application/x-httpd-php",
        pdf: "application/pdf",
        pgp: "application/pgp",
        png: "image/png",
        pps: "application/mspowerpoint",
        ppt: "application/mspowerpoint",
        ppz: "application/mspowerpoint",
        pot: "application/mspowerpoint",
        ps: "application/postscript",
        qt: "video/quicktime",
        qd3d: "x-world/x-3dmf",
        qd3: "x-world/x-3dmf",
        qxd: "application/x-quark-express",
        rar: "application/x-rar-compressed",
        ra: "audio/x-realaudio",
        ram: "audio/x-pn-realaudio",
        rm: "audio/x-pn-realaudio",
        rtf: "text/rtf",
        spr: "application/x-sprite",
        sprite: "application/x-sprite",
        stream: "audio/x-qt-stream",
        swf: "application/x-shockwave-flash",
        svg: "text/xml-svg",
        sgml: "text/x-sgml",
        sgm: "text/x-sgml",
        tar: "application/x-tar",
        tiff: "image/tiff",
        tif: "image/tiff",
        tgz: "application/x-compressed",
        tex: "application/x-tex",
        txt: "text/plain",
        vob: "video/x-mpg",
        wav: "audio/x-wav",
        wrl: "x-world/x-vrml",
        // xla: "application/msexcel",
        xla: "application/vnd.ms-excel",
        // xlsx: "application/msexcel",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xls: "application/vnd.ms-excel",
        xlc: "application/vnd.ms-excel",
        xml: "text/xml",
        zip: "application/zip",
    };

    static offlineTables = [
        {
            table_name: "DeviceDetails",
            columns: [
                {
                    name: "deviceDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "activationDate", type: "VARCHAR(32)" },
                { name: "companyFolderName", type: "VARCHAR(32)" },
                { name: "companyID", type: "INTEGER" },
                { name: "createdBy", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "deviceID", type: "INTEGER" },
                { name: "deviceName", type: "VARCHAR(32)" },
                { name: "deviceUniqueID", type: "VARCHAR(32)" },
                { name: "entities", type: "TEXT" },
                { name: "entityNames", type: "TEXT" },
                { name: "formattedLastSynchDate", type: "VARCHAR(32)" },
                { name: "lastSeenDate", type: "VARCHAR(32)" },
                { name: "lastSynchDate", type: "VARCHAR(32)" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "noOfInventoryItems", type: "INTEGER" },
                { name: "noOfLocations", type: "INTEGER" },
                { name: "noOfPorjects", type: "INTEGER" },
                { name: "timeDifference", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceEntities",
            columns: [
                {
                    name: "deviceEntityDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInPersonalQR", type: "BOOLEAN" },
                { name: "createdBy", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "deviceEntityID", type: "INTEGER" },
                { name: "deviceID", type: "INTEGER" },
                { name: "documents", type: "INTEGER" },
                { name: "forms", type: "INTEGER" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "itemName", type: "VARCHAR(32)" },
                { name: "locationID", type: "INTEGER" },
                { name: "locationName", type: "VARCHAR(32)" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "permits", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "projectName", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceUsers",
            columns: [
                {
                    name: "DeviceUserId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyID", type: "INTEGER" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "middleName", type: "VARCHAR(32)" },
                { name: "photo", type: "TEXT" },
                { name: "qrCode", type: "TEXT" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "userAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "userId", type: "VARCHAR(32)" },
                { name: "userPhoto", type: "VARCHAR(32)" },
                { name: "userQualifications", type: "TEXT" },
            ],
        },
        {
            table_name: "DeviceUserQualifications",
            columns: [
                {
                    name: "DeviceUserQualificationId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "qualificationID", type: "INTEGER" },
                { name: "userId", type: "VARCHAR(32)" },
                { name: "expireDate", type: "VARCHAR(32)" },
                { name: "formattedExpireDate", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceGuestUsers",
            columns: [
                {
                    name: "deviceGuestUserId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "guestFirsName", type: "VARCHAR(32)" },
                { name: "guestLastName", type: "VARCHAR(32)" },
                { name: "guestMiddleName", type: "VARCHAR(32)" },
                { name: "guestPhone", type: "VARCHAR(32)" },
                { name: "guestPhoto", type: "TEXT" },
                { name: "guestPhotoImageVideoFileId", type: "INTEGER" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "DeviceAvailableDocuments",
            columns: [
                {
                    name: "deviceAvailableDocumentId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "folderID", type: "INTEGER" },
                { name: "documentID", type: "INTEGER" },
                { name: "documentVersionID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileIconURL", type: "VARCHAR(32)" },
                { name: "isReviewal", type: "BOOLEAN" },
                { name: "reviewerId", type: "VARCHAR(32)" },
                { name: "isSystemReviewer", type: "BOOLEAN" },
                { name: "isEmailReviewer", type: "BOOLEAN" },
                { name: "isSmsReviewer", type: "BOOLEAN" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "documentVersionNo", type: "INTEGER" },
                { name: "expirationDate", type: "VARCHAR(32)" },
                { name: "formattedCreatedDate", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "parentFolderID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "timeDifference", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceArchivedDocuments",
            columns: [
                {
                    name: "deviceArchivedDocumentId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "documentID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "formattedCreatedDate", type: "VARCHAR(32)" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "signedByName", type: "VARCHAR(32)" },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileIconURL", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "signOffDetailId", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceAvailableForms",
            columns: [
                {
                    name: "deviceAvailableFormId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "formAttachments", type: "TEXT" },
                { name: "formFolderID", type: "INTEGER" },
                { name: "formID", type: "INTEGER" },
                { name: "formTitle", type: "VARCHAR(32)" },
                { name: "formType", type: "VARCHAR(32)" },
                { name: "formVersionID", type: "INTEGER" },
                { name: "formVersionNo", type: "INTEGER" },
                { name: "formattedDescription", type: "VARCHAR(32)" },
                { name: "formattedInstructions", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isEmailReviewer", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "isReviewal", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "isSmsReviewer", type: "BOOLEAN" },
                { name: "isSystemReviewer", type: "BOOLEAN" },
                { name: "isLimitAccessApplied", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "parentFormFolderID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "reviewerId", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceArchivedForms",
            columns: [
                {
                    name: "deviceArchivedFormId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileIconURL", type: "VARCHAR(32)" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "documentID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "formattedCreatedDate", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "isLimitAccessApplied", type: "BOOLEAN" },
                { name: "signedByName", type: "VARCHAR(32)" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "formSubmitDataId", type: "INTEGER" },
                { name: "signOffDetailId", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceAvailableWorkPermits",
            columns: [
                {
                    name: "deviceAvailableWorkPermitId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "formAttachments", type: "TEXT" },
                { name: "formFolderID", type: "INTEGER" },
                { name: "formID", type: "INTEGER" },
                { name: "formTitle", type: "VARCHAR(32)" },
                { name: "formType", type: "VARCHAR(32)" },
                { name: "formVersionID", type: "INTEGER" },
                { name: "formVersionNo", type: "INTEGER" },
                { name: "formattedDescription", type: "VARCHAR(32)" },
                { name: "formattedInstructions", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isEmailReviewer", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "isReviewal", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "isSmsReviewer", type: "BOOLEAN" },
                { name: "isSystemReviewer", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "parentFormFolderID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "reviewerId", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceLiveWorkPermits",
            columns: [
                {
                    name: "deviceLiveWorkPermitId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "userWorkPermitId", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "expiryDate", type: "VARCHAR(32)" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "formTitle", type: "VARCHAR(32)" },
                { name: "formattedExpiryDate", type: "VARCHAR(32)" },
                { name: "formattedIssuedDate", type: "VARCHAR(32)" },
                { name: "issuedDate", type: "VARCHAR(32)" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "middleName", type: "VARCHAR(32)" },
                { name: "photo", type: "VARCHAR(32)" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "DeviceArchivedWorkPermits",
            columns: [
                {
                    name: "deviceArchivedWorkPermitId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "userWorkPermitId", type: "INTEGER" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "middleName", type: "VARCHAR(32)" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "photo", type: "TEXT" },
                { name: "formTitle", type: "VARCHAR(32)" },
                { name: "issuedDate", type: "VARCHAR(32)" },
                { name: "formattedIssuedDate", type: "VARCHAR(32)" },
                { name: "expiryDate", type: "VARCHAR(32)" },
                { name: "formattedExpiryDate", type: "VARCHAR(32)" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceFormDetails",
            columns: [
                {
                    name: "deviceFormDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "formAttachments", type: "TEXT" },
                { name: "formFolderID", type: "INTEGER" },
                { name: "formID", type: "INTEGER" },
                { name: "formTitle", type: "VARCHAR(32)" },
                { name: "formType", type: "VARCHAR(32)" },
                { name: "formVersionID", type: "INTEGER" },
                { name: "formVersionNo", type: "INTEGER" },
                { name: "formattedDescription", type: "VARCHAR(32)" },
                { name: "formattedInstructions", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isEmailReviewer", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "isReviewal", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "isSmsReviewer", type: "BOOLEAN" },
                { name: "isSystemReviewer", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "parentFormFolderID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "reviewerId", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceFormAttachments",
            columns: [
                {
                    name: "deviceFormAttachmentId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileIconURL", type: "VARCHAR(32)" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "documentID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "formID", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceEvacuations",
            columns: [
                {
                    name: "deviceEvacuationId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "firstAndLastName", type: "VARCHAR(32)" },
                { name: "userId", type: "VARCHAR(32)" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "userDetailPhoto", type: "TEXT" },
                { name: "userPhoto", type: "TEXT" },
                { name: "userPhotoImageVideoFileId", type: "INTEGER" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "DeviceUserCheckInQualifications",
            columns: [
                {
                    name: "deviceUserCheckInQualificationId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "qualificationID", type: "INTEGER" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceLocations",
            columns: [
                {
                    name: "deviceLocationId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "additionalNote", type: "VARCHAR(32)" },
                { name: "address", type: "VARCHAR(32)" },
                { name: "autoCheckOutHour", type: "INTEGER" },
                { name: "autoCheckOutTime", type: "VARCHAR(32)" },
                { name: "checkInGuestPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalQR", type: "BOOLEAN" },
                { name: "cityName", type: "VARCHAR(32)" },
                { name: "companyID", type: "INTEGER" },
                { name: "countryID", type: "INTEGER" },
                { name: "createdBy", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "description", type: "VARCHAR(32)" },
                { name: "isAutoAssign", type: "BOOLEAN" },
                { name: "isSimultaneousCheckIn", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "locationName", type: "VARCHAR(32)" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "ownerId", type: "VARCHAR(32)" },
                { name: "postCode", type: "VARCHAR(32)" },
                { name: "qrCode", type: "VARCHAR(32)" },
                { name: "stateName", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceProjects",
            columns: [
                {
                    name: "deviceProjectId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "additionalNote", type: "VARCHAR(32)" },
                { name: "autoCheckOutHour", type: "INTEGER" },
                { name: "autoCheckOutTime", type: "VARCHAR(32)" },
                { name: "checkInGuestPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalQR", type: "BOOLEAN" },
                { name: "companyID", type: "INTEGER" },
                { name: "createdBy", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "description", type: "VARCHAR(32)" },
                { name: "isAutoAssign", type: "BOOLEAN" },
                { name: "isSimultaneousCheckIn", type: "BOOLEAN" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "ownerId", type: "VARCHAR(32)" },
                { name: "projectEndDate", type: "VARCHAR(32)" },
                { name: "projectID", type: "INTEGER" },
                { name: "projectName", type: "VARCHAR(32)" },
                { name: "projectStartDate", type: "VARCHAR(32)" },
                { name: "qrCode", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceInventoryItems",
            columns: [
                {
                    name: "deviceInventoryItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "additionalNote", type: "VARCHAR(32)" },
                { name: "autoCheckOutHour", type: "INTEGER" },
                { name: "autoCheckOutTime", type: "VARCHAR(32)" },
                { name: "checkInGuestPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalPhoto", type: "BOOLEAN" },
                { name: "checkInPersonalQR", type: "BOOLEAN" },
                { name: "companyID", type: "INTEGER" },
                { name: "createdBy", type: "VARCHAR(32)" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "havManufacturerID", type: "INTEGER" },
                { name: "havModelID", type: "INTEGER" },
                { name: "havTypeID", type: "INTEGER" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isAutoAssign", type: "BOOLEAN" },
                { name: "isHAVSData", type: "BOOLEAN" },
                { name: "isSimultaneousCheckIn", type: "BOOLEAN" },
                { name: "itemName", type: "VARCHAR(32)" },
                { name: "itemPhoto", type: "TEXT" },
                { name: "itemType", type: "VARCHAR(32)" },
                { name: "kFactor", type: "VARCHAR(32)" },
                { name: "model", type: "VARCHAR(32)" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "ownerId", type: "VARCHAR(32)" },
                { name: "qrCode", type: "TEXT" },
                { name: "vibrationValue", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceUserCheckinDetails",
            columns: [
                {
                    name: "deviceUserCheckinDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "answerNotificationList", type: "VARCHAR(32)" },
                { name: "checkInDate", type: "VARCHAR(32)" },
                { name: "checkInLatitude", type: "VARCHAR(32)" },
                { name: "checkInLocation", type: "VARCHAR(32)" },
                { name: "checkInLongitude", type: "VARCHAR(32)" },
                { name: "checkOutDate", type: "VARCHAR(32)" },
                { name: "checkOutLatitude", type: "VARCHAR(32)" },
                { name: "checkOutLocation", type: "VARCHAR(32)" },
                { name: "checkOutLongitude", type: "VARCHAR(32)" },
                { name: "companyID", type: "INTEGER" },
                { name: "currentUTCDate", type: "VARCHAR(32)" },
                { name: "digitalInkSignature", type: "VARCHAR(32)" },
                {
                    name: "digitalInkSignatureImageVideoFileId",
                    type: "INTEGER",
                },
                { name: "entityName", type: "VARCHAR(32)" },
                { name: "firstAndLastName", type: "VARCHAR(32)" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "guestFirsName", type: "VARCHAR(32)" },
                { name: "guestLastName", type: "VARCHAR(32)" },
                { name: "guestMiddleName", type: "VARCHAR(32)" },
                { name: "guestPhone", type: "VARCHAR(32)" },
                { name: "guestPhoto", type: "VARCHAR(32)" },
                { name: "guestPhotoImageVideoFileId", type: "INTEGER" },
                { name: "inductionFormContent", type: "VARCHAR(32)" },
                { name: "formSubmitDataId", type: "VARCHAR(32)" }, // for get formdata from offline FormSubmitData table while sync to server
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isGuestReturning", type: "BOOLEAN" },
                { name: "isPhone", type: "BOOLEAN" },
                { name: "isSimultaneousCheckIn", type: "BOOLEAN" },
                { name: "processInductionsteps", type: "BOOLEAN" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "locationAutoCheckOutHour", type: "INTEGER" },
                { name: "locationAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "locationID", type: "INTEGER" },
                { name: "positionName", type: "VARCHAR(32)" },
                { name: "projectID", type: "INTEGER" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "userAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "userCheckInDetailID", type: "INTEGER" },
                { name: "userDetailPhoto", type: "VARCHAR(32)" },
                { name: "userId", type: "VARCHAR(32)" },
                { name: "userPhoto", type: "TEXT" },
                { name: "userPhotoImageVideoFileId", type: "INTEGER" },
                { name: "userType", type: "VARCHAR(32)" },
                { name: "userSignaturePhoto", type: "VARCHAR(32)" },
                { name: "userSignaturePhotoImageVideoFileId", type: "INTEGER" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "DeviceCheckInInductions",
            columns: [
                {
                    name: "deviceCheckInInductionId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInInductionID", type: "INTEGER" },
                { name: "inductionItems", type: "TEXT" },
                { name: "introduction", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "renewEveryPeriod", type: "INTEGER" },
                { name: "renewEveryPeriodType", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceCheckInInductionItems",
            columns: [
                {
                    name: "deviceCheckInInductionItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInInductionID", type: "INTEGER" },
                { name: "checkInInductionItemID", type: "INTEGER" },
                { name: "contentDetails", type: "VARCHAR(32)" },
                { name: "contentType", type: "VARCHAR(32)" },
                { name: "displayOrder", type: "INTEGER" },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "documentID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "formID", type: "INTEGER" },
                { name: "formType", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceGuestUserCheckinDetails",
            columns: [
                {
                    name: "deviceGuestUserCheckinDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "answerNotificationList", type: "VARCHAR(32)" },
                { name: "checkInDate", type: "VARCHAR(32)" },
                { name: "checkInLatitude", type: "VARCHAR(32)" },
                { name: "checkInLocation", type: "VARCHAR(32)" },
                { name: "checkInLongitude", type: "VARCHAR(32)" },
                { name: "checkOutDate", type: "VARCHAR(32)" },
                { name: "checkOutLatitude", type: "VARCHAR(32)" },
                { name: "checkOutLocation", type: "VARCHAR(32)" },
                { name: "checkOutLongitude", type: "VARCHAR(32)" },
                { name: "companyID", type: "INTEGER" },
                { name: "currentUTCDate", type: "VARCHAR(32)" },
                { name: "digitalInkSignature", type: "VARCHAR(32)" },
                {
                    name: "digitalInkSignatureImageVideoFileId",
                    type: "INTEGER",
                },
                { name: "entityName", type: "VARCHAR(32)" },
                { name: "firstAndLastName", type: "VARCHAR(32)" },
                { name: "firstName", type: "VARCHAR(32)" },
                { name: "guestFirsName", type: "VARCHAR(32)" },
                { name: "guestLastName", type: "VARCHAR(32)" },
                { name: "guestMiddleName", type: "VARCHAR(32)" },
                { name: "guestPhone", type: "VARCHAR(32)" },
                { name: "guestPhoto", type: "TEXT" },
                { name: "guestPhotoImageVideoFileId", type: "INTEGER" },
                { name: "inductionFormContent", type: "VARCHAR(32)" },
                { name: "formSubmitDataId", type: "VARCHAR(32)" }, // for get formdata from offline FormSubmitData table while sync to server
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isGuestReturning", type: "BOOLEAN" },
                { name: "isPhone", type: "BOOLEAN" },
                { name: "isSimultaneousCheckIn", type: "BOOLEAN" },
                { name: "processInductionsteps", type: "BOOLEAN" },
                { name: "lastName", type: "VARCHAR(32)" },
                { name: "locationAutoCheckOutHour", type: "INTEGER" },
                { name: "locationAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "locationID", type: "INTEGER" },
                { name: "positionName", type: "VARCHAR(32)" },
                { name: "projectID", type: "INTEGER" },
                { name: "timeDifference", type: "VARCHAR(32)" },
                { name: "userAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "userCheckInDetailID", type: "INTEGER" },
                { name: "userDetailPhoto", type: "VARCHAR(32)" },
                { name: "userId", type: "INTEGER" },
                { name: "userPhoto", type: "VARCHAR(32)" },
                { name: "userSignaturePhoto", type: "VARCHAR(32)" },
                { name: "userSignaturePhotoImageVideoFileId", type: "INTEGER" },
                { name: "userType", type: "VARCHAR(32)" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },

        {
            table_name: "DeviceCheckInGuestInductions",
            columns: [
                {
                    name: "deviceCheckInGuestInductionId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInInductionGuestID", type: "INTEGER" },
                { name: "guestInductionItems", type: "TEXT" },
                { name: "introduction", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "isDigitalSignOff", type: "BOOLEAN" },
                { name: "isPhotoSignOff", type: "BOOLEAN" },
                { name: "isSignatureSignOff", type: "BOOLEAN" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "renewEveryPeriod", type: "INTEGER" },
                { name: "renewEveryPeriodType", type: "VARCHAR(32)" },
            ],
        },

        {
            table_name: "DeviceCheckInGuestInductionItems",
            columns: [
                {
                    name: "deviceCheckInGuestInductionItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInInductionGuestID", type: "INTEGER" },
                { name: "checkInInductionGuestItemID", type: "INTEGER" },
                { name: "contentDetails", type: "TEXT" },
                { name: "contentType", type: "VARCHAR(32)" },
                { name: "displayOrder", type: "INTEGER" },
                { name: "documentFileFormat", type: "VARCHAR(32)" },
                { name: "documentFileName", type: "VARCHAR(32)" },
                { name: "documentID", type: "INTEGER" },
                { name: "documentTitle", type: "VARCHAR(32)" },
                { name: "formID", type: "INTEGER" },
                { name: "formType", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceUserLastCheckinDetailList",
            columns: [
                {
                    name: "deviceUserLastCheckinDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInDate", type: "VARCHAR(32)" },
                { name: "checkOutDate", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "showInductionSteps", type: "BOOLEAN" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "userCheckInDetailID", type: "INTEGER" },
                { name: "isOfflineDone", type: "BOOLEAN" },
                { name: "userId", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceGuestUserLastCheckinDetailList",
            columns: [
                {
                    name: "deviceGuestUserLastCheckinDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "checkInDate", type: "VARCHAR(32)" },
                { name: "checkOutDate", type: "VARCHAR(32)" },
                { name: "guestFirsName", type: "VARCHAR(32)" },
                { name: "guestLastName", type: "VARCHAR(32)" },
                { name: "guestMiddleName", type: "VARCHAR(32)" },
                { name: "guestPhone", type: "VARCHAR(32)" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "showInductionSteps", type: "BOOLEAN" },
                { name: "todayDate", type: "VARCHAR(32)" },
                { name: "isOfflineDone", type: "BOOLEAN" },
                { name: "userCheckInDetailID", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceLocationItems",
            columns: [
                {
                    name: "deviceLocationItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "currentUTCDate", type: "VARCHAR(32)" },
                { name: "locationAutoCheckOutHour", type: "VARCHAR(32)" },
                { name: "locationAutoCheckOutTime", type: "VARCHAR(32)" },
                { name: "locationID", type: "VARCHAR(32)" },
                { name: "locationName", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceCompanyUsers",
            columns: [
                {
                    name: "deviceCompanyUserId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "firstAndLastName", type: "VARCHAR(32)" },
                { name: "userId", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceCompanyUserGroups",
            columns: [
                {
                    name: "deviceCompanyUserGroupId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "groupName", type: "VARCHAR(32)" },
                { name: "userGroupID", type: "INTEGER" },
            ],
        },
        {
            table_name: "DeviceHAVManufacturers",
            columns: [
                {
                    name: "deviceHAVManufacturerId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyID", type: "INTEGER" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "havManufacturerID", type: "INTEGER" },
                { name: "havManufacturerName", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceHAVTypes",
            columns: [
                {
                    name: "deviceHAVTypeId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyID", type: "INTEGER" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "havManufacturerID", type: "INTEGER" },
                { name: "havManufacturerName", type: "VARCHAR(32)" },
                { name: "havTypeID", type: "INTEGER" },
                { name: "havTypeName", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceHAVModels",
            columns: [
                {
                    name: "DeviceHAVModelId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyID", type: "INTEGER" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "havManufacturerID", type: "INTEGER" },
                { name: "havManufacturerName", type: "VARCHAR(32)" },
                { name: "havModelID", type: "INTEGER" },
                { name: "havTypeID", type: "INTEGER" },
                { name: "havTypeName", type: "VARCHAR(32)" },
                { name: "kFactor", type: "VARCHAR(32)" },
                { name: "model", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "vibrationValue", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceRiskItems",
            columns: [
                {
                    name: "deviceRiskItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyID", type: "INTEGER" },
                { name: "companyRiskItemID", type: "INTEGER" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "riskItemName", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceHazardItems",
            columns: [
                {
                    name: "deviceHazardItemId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "companyHazardItemID", type: "INTEGER" },
                { name: "companyID", type: "INTEGER" },
                { name: "companyRiskItemID", type: "INTEGER" },
                { name: "createdDate", type: "VARCHAR(32)" },
                { name: "hazardItemName", type: "VARCHAR(32)" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "riskItemName", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceAnswerChoiceQrCodeEntities",
            columns: [
                {
                    name: "deviceAnswerChoiceQrCodeEntityId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "entityID", type: "VARCHAR(32)" },
                { name: "entityName", type: "VARCHAR(32)" },
                { name: "entityType", type: "VARCHAR(32)" },
                { name: "havManufacturerID", type: "INTEGER" },
                { name: "havModelID", type: "INTEGER" },
                { name: "havTypeID", type: "INTEGER" },
                { name: "isHAVSData", type: "BOOLEAN" },
                { name: "qrCode", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceAccidentTypes",
            columns: [
                {
                    name: "deviceAccidentTypeId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "accidentTypeId", type: "INTEGER" },
                { name: "accidentTypeTitle", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceAccidentClassifications",
            columns: [
                {
                    name: "deviceAccidentClassificationId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "accidentClassificationCode", type: "VARCHAR(32)" },
                {
                    name: "accidentClassificationDescription",
                    type: "VARCHAR(32)",
                },
                { name: "accidentClassificationId", type: "INTEGER" },
                { name: "accidentClassificationTitle", type: "VARCHAR(32)" },
            ],
        },
        {
            table_name: "DeviceRiskAssessmentSeverityOptions",
            columns: [
                {
                    name: "deviceRiskAssessmentSeverityOptionId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                {
                    name: "riskAssessmentSeverityOptionColor",
                    type: "VARCHAR(32)",
                },
                { name: "riskAssessmentSeverityOptionId", type: "INTEGER" },
                {
                    name: "riskAssessmentSeverityOptionTitle",
                    type: "VARCHAR(32)",
                },
            ],
        },
        {
            table_name: "DeviceRiskAssessmentProbabilityOptions",
            columns: [
                {
                    name: "deviceRiskAssessmentProbabilityOptionId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                {
                    name: "riskAssessmentProbabilityOptionColor",
                    type: "VARCHAR(32)",
                },
                { name: "riskAssessmentProbabilityOptionId", type: "INTEGER" },
                {
                    name: "riskAssessmentProbabilityOptionTitle",
                    type: "VARCHAR(32)",
                },
            ],
        },
        {
            table_name: "DeviceUserTotalHAVExposures",
            columns: [
                {
                    name: "deviceUserTotalHAVExposureId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "exposurePoints", type: "INTEGER" },
                { name: "modifiedDate", type: "VARCHAR(32)" },
                { name: "userID", type: "VARCHAR(32)" },
                { name: "isOfflineDone", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "DeviceFormBuilderDetails",
            columns: [
                {
                    name: "deviceFormBuilderDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "accidentReport", type: "TEXT" },
                { name: "answerChoiceColors", type: "TEXT" },
                { name: "answerTypes", type: "TEXT" },
                { name: "companyId", type: "INTEGER" },
                { name: "defaultLanguageId", type: "INTEGER" },
                { name: "description", type: "TEXT" },
                { name: "folderDocumentList", type: "TEXT" },
                { name: "folderDocumentTreeList", type: "TEXT" },
                { name: "formId", type: "INTEGER" },
                { name: "formTypeID", type: "INTEGER" },
                { name: "formVersionId", type: "INTEGER" },
                { name: "formVersionNo", type: "INTEGER" },
                { name: "groupList", type: "TEXT" },
                { name: "hourFormats", type: "TEXT" },
                { name: "isDraft", type: "BOOLEAN" },
                { name: "isPreview", type: "BOOLEAN" },
                { name: "modifiedBy", type: "VARCHAR(32)" },
                { name: "questionActionOnList", type: "TEXT" },
                { name: "questionActionTypes", type: "TEXT" },
                { name: "questionActivityTypes", type: "TEXT" },
                { name: "questionChoiceSetTypes", type: "TEXT" },
                { name: "questionOperatorTypes", type: "TEXT" },
                { name: "riskAssessmentDetails", type: "TEXT" },
                { name: "sections", type: "TEXT" },
                { name: "selectedLanguage", type: "VARCHAR(32)" },
                { name: "selectedLanguages", type: "TEXT" },
                { name: "signedUsers", type: "TEXT" },
                { name: "supportedLanguages", type: "TEXT" },
                { name: "taskTemplates", type: "TEXT" },
                { name: "title", type: "VARCHAR(32)" },
                { name: "userList", type: "TEXT" },
                { name: "workPermitDetails", type: "TEXT" },
                { name: "isFormScoringEnabled", type: "BOOLEAN" },
                { name: "isShowScoreInApp", type: "BOOLEAN" },
                { name: "isShowTScoreInPDF", type: "BOOLEAN" },
                { name: "isShowSScoreInPDF", type: "BOOLEAN" },
            ],
        },
        {
            table_name: "FormSubmitData",
            columns: [
                {
                    name: "formSubmitDataId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "formId", type: "INTEGER" },
                { name: "formVersionId", type: "INTEGER" },
                { name: "formTypeId", type: "INTEGER" },
                { name: "userId", type: "VARCHAR(32)" },
                { name: "guest_FirstName", type: "VARCHAR(32)" },
                { name: "guest_MiddleName", type: "VARCHAR(32)" },
                { name: "guest_LastName", type: "VARCHAR(32)" },
                { name: "guest_Phone", type: "VARCHAR(32)" },
                { name: "companyId", type: "INTEGER" },
                { name: "selectedLanguageID", type: "INTEGER" },
                { name: "questionAnswers", type: "TEXT" },
                { name: "accidentReportQuestionAnswers", type: "TEXT" },
                { name: "riskAssessmentAnswers", type: "TEXT" },
                { name: "havAnswerDetail", type: "TEXT" },
                { name: "workPermitAnswer", type: "TEXT" },
                { name: "formattedSections", type: "TEXT" },
                { name: "workPermitDetails", type: "TEXT" },
                { name: "accidentReport", type: "TEXT" },
                { name: "riskAssessmentAnswerDetails", type: "TEXT" },
                { name: "entityId", type: "TEXT" },
            ],
        },
        {
            table_name: "ImageVideoFiles",
            columns: [
                {
                    name: "imageVideoFileId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "fileUsedIn", type: "VARCHAR(32)" },
                { name: "fileName", type: "VARCHAR(32)" },
                { name: "originalFileName", type: "VARCHAR(255)" },
            ],
        },
        {
            table_name: "SignOffDetails",
            columns: [
                {
                    name: "signOffDetailId",
                    type: "INTEGER PRIMARY KEY AUTOINCREMENT",
                },
                { name: "userId", type: "INTEGER" },
                { name: "activityIndividualID", type: "INTEGER" },
                { name: "documentVersionID", type: "INTEGER" },
                { name: "formVersionID", type: "INTEGER" },
                { name: "locationID", type: "INTEGER" },
                { name: "projectID", type: "INTEGER" },
                { name: "inventoryItemID", type: "INTEGER" },
                { name: "latitude", type: "VARCHAR(32)" },
                { name: "longitude", type: "VARCHAR(32)" },
                { name: "userSignaturePhotoImageVideoFileId", type: "INTEGER" },
                {
                    name: "digitalInkSignatureImageVideoFileId",
                    type: "INTEGER",
                },
                { name: "documentID", type: "INTEGER" },
                { name: "signOffDate", type: "VARCHAR(32)" },
                { name: "formSubmitDataId", type: "INTEGER" },
                { name: "isSubmitting", type: "INTEGER DEFAULT 0" },
                { name: "idempotencyKey", type: "VARCHAR(255)" },
                { name: "formSubmittedOnline", type: "INTEGER DEFAULT 0" },
                { name: "signOffPayload", type: "TEXT" },
                { name: "fullPayloadJson", type: "TEXT" },
            ],
        },
        {
            table_name: "DeviceIOSHHarmTypes",
            columns: [
                { name: "id", type: "INTEGER PRIMARY KEY AUTOINCREMENT" },
                { name: "companyIosHarmTypeID", type: "INTEGER" },
                { name: "ioshHarmName", type: "TEXT" },
                { name: "companyID", type: "INTEGER" },
            ]
          },
          {
            table_name: "DeviceIOSHHazardCategories",
            columns: [
              { name: "id", type: "INTEGER PRIMARY KEY AUTOINCREMENT" },
              { name: "companyIoshHazardCategoryID", type: "INTEGER" },
              { name: "ioshHazardName", type: "TEXT" },
              { name: "companyID", type: "INTEGER" },
            ]
          },
          {
            table_name: "DeviceIOSHHazardControls",
            columns: [
              { name: "id", type: "INTEGER PRIMARY KEY AUTOINCREMENT" },
              { name: "companyIoshHazardControlID", type: "INTEGER" },
              { name: "ioshHazardControlName", type: "TEXT" },
              { name: "companyIoshHazardCategoryID", type: "INTEGER" },
              { name: "companyID", type: "INTEGER" },
            ]
          }
    ];
}
